module.exports = __webpack_public_path__ + "img/fotos_2.927d45f6.jpg";